/* istanbul ignore file */
import { FC, PropsWithChildren } from 'react';
import './card.css';

const Card: FC<PropsWithChildren> = ({ children }) => <div className='card'>{children}</div>;

export default Card;
